import React, {ReactNode} from 'react';
import {Box, Container} from '@mui/material';
import DownloadStoreButton from '../generalPurpose/downloadStoreButton';
import Breadcrumb from '../generalPurpose/Breadcrumb';
import BackButton from '../generalPurpose/BackButton';
import GlobalHeader from '../generalPurpose/GlobalHeader';

interface Props {
  children: ReactNode;
  links: {name: string; url: string}[];
  isThereBackButton?: boolean;
  BackButtonTitle?: string;
}

export default function PageContainer(props: Props) {
  const {
    children,
    links,
    isThereBackButton = false,
    BackButtonTitle = 'Back to All Tools',
  } = props;
  const Children = children;

  return (
    <GlobalHeader>
      <div>
        <Container style={styles.container}>
          <Breadcrumb links={links} />
          {isThereBackButton && (
            <BackButton
              title={BackButtonTitle}
              BackToScreen={links[links.length - 2].url}
            />
          )}
          <Box>{Children}</Box>
          <p style={styles.subDescription as React.CSSProperties}>
            <b>
              Get quick access to the mobile version of Point-of-Care tools now.
            </b>
            &nbsp;The ACEP Mobile app with helpful bedside tools provides
            clinical content and tools for EM physicians to utilize while
            providing care in the ED.
          </p>
          <DownloadStoreButton
            downloadURL="https://play.google.com/store/apps/details?id=com.acepmobile"
            store="google"
          />
          <DownloadStoreButton
            downloadURL="https://apps.apple.com/us/app/acep-mobile/id1623855450"
            store="apple"
          />
        </Container>
      </div>
    </GlobalHeader>
  );
}

const styles = {
  container: {
    paddingTop: 21,
    marginBottom: '5%',
  },
  subDescription: {
    fontSize: 17,
    marginTop: 42,
    fontWeight: '400',
    lineHeight: '140%',
  },
};
